<template>
  <div class="form-wrap">
    <Row class="detail-title"> {{ detail.caseCode }} </Row>
    <Row v-if="materialDetail" class="case-content">
      <Row v-if="type == 'F'" class="detail-content">
        <Row><Col class="left-label" span="3">款项类型：</Col><Col span="18" class="textover right-content">{{ paymentType }}</Col></Row>
        <Row><Col class="left-label" span="3">赔偿款申请金额：</Col><Col span="18" class="textover right-content">{{ common.formateNumber(materialDetail.comFee || "") }}</Col></Row>
        <Row><Col class="left-label" span="3">诉讼退费申请金额：</Col><Col span="18" class="textover right-content">{{ common.formateNumber(materialDetail.backFee || "") }}</Col></Row>
        <Row>
          <Col class="left-label" span="3">附件：</Col>
          <Col span="18" class="textover right-content">
            <file-upload
              :default-list="materialDetail.attachmentDTOList || []"
              :upload-config="{readOnly:true}"
            />
          </Col>
        </Row>
        <Row><Col class="left-label" span="3">是否加盖私章：</Col><Col span="18" class="textover right-content">{{ materialDetail.privateSeal ? '是':'否' }}</Col></Row>
        <Row><Col class="left-label" span="3">是否开具收据：</Col><Col span="18" class="textover right-content">{{ materialDetail.hasReceipt?'是':'否' }}</Col></Row>

        <Row>
          <Col
            class="left-label"
            span="3"
          >
            附件申请份数：
          </Col><Col span="18" class="textover right-content">{{ materialDetail.printNum || '' }}</Col>
        </Row>
        <Row v-if=" materialDetail.hasReceipt">
          <Col
            class="left-label"
            span="3"
          >
            收据内容：
          </Col><Col span="18" class="textover right-content">{{ materialDetail.receiptContent || '' }}</Col>
        </Row>
        <Row v-if=" materialDetail.hasReceipt"><Col class="left-label" span="3">盖章类型：</Col><Col span="18" class="textover right-content">{{ stampType || '' }}</Col></Row>
        <Row><Col class="left-label" span="3">备注：</Col><Col span="18" class=" right-content">{{ materialDetail.memo || '' }}</Col></Row>
      </Row>
      <Row v-if="type == 'S'" class="detail-content">
        <Row><Col class="left-label" span="3">材料类型：</Col><Col span="18" class="textover right-content">{{ materialDetail.fileSubTypeName }}</Col></Row>
        <Row>
          <Col class="left-label" span="3">{{ materialDetail.fileSubTypeName =='SS'? '上诉状:' : ' 再审申请书:' }}</Col>
          <Col span="18" class="textover right-content">
            <file-upload
              :default-list="materialDetail.fileSHAttachmentList || []"
              :upload-config="{readOnly:true}"
            />
          </Col>
        </Row>
        <Row>
          <Col
            class="left-label"
            span="3"
          >
            {{ materialDetail.fileSubTypeName =='SS'? '上诉状份数:' : ' 再审申请书份数:' }}

          </Col><Col span="18" class="textover right-content">{{ materialDetail.fileSHPrintNum || '' }}</Col>
        </Row>
        <Row>
          <Col class="left-label" span="3">授权委托书：</Col>
          <Col span="18" class="textover right-content">
            <file-upload
              :default-list="materialDetail.fileWTAttachmentList || []"
              :upload-config="{readOnly:true}"
            />
          </Col>
        </Row>
        <Row>
          <Col
            class="left-label"
            span="3"
          >
            委托书份数:
          </Col><Col span="18" class="textover right-content">{{ materialDetail.fileWTPrintNum || '' }}</Col>
        </Row>
        <Row><Col class="left-label" span="3">是否加盖私章：</Col><Col span="18" class="textover right-content">{{ materialDetail.privateSeal ? '是':'否' }}</Col></Row>
        <Row><Col class="left-label" span="3">备注：</Col><Col span="18" class=" right-content">{{ materialDetail.memo || '' }}</Col></Row>
      </Row>
      <Row v-if="type == 'Q'" class="detail-content">
        <Row v-for="(item,index) in materialDetail.details" :key="index">
          <Row class="title">{{ '材料'+ (index+1) }}</Row>
          <Row><Col class="left-label" span="4">材料名称：</Col><Col span="18" class="textover right-content">{{ item.fileSubTypeName }}</Col></Row>
          <Row>
            <Col class="left-label" span="4">附件：</Col>
            <Col span="18" class="textover right-content">
              <file-upload
                :default-list="[item.attachment] || []"
                :upload-config="{readOnly:true}"
              />
            </Col>
          </Row>
          <Row>
            <Col
              class="left-label"
              span="4"
            >
              附件申请份数：
            </Col><Col span="18" class="textover right-content">{{ item.printNum || '' }}</Col>
          </Row>
        </Row>
        <Row class="title">{{ '其他信息' }}</Row>
        <Row><Col class="left-label" span="4">是否加盖私章：</Col><Col span="18" class="textover right-content">{{ materialDetail.privateSeal ? '是':'否' }}</Col></Row>
        <Row><Col class="left-label" span="4">备注：</Col><Col span="18" class=" right-content">{{ materialDetail.memo || '' }}</Col></Row>
      </Row>
    </Row>

  </div>
</template>
<script>
export default {
  components: {
  },
  props: ['detail', 'type'],
  // type   F 领款   S 上诉   Q  其他
  data () {
    return {
      materialDetail: null
    }
  },
  computed: {
    paymentType() {
      if (this.materialDetail.backFeeFlag && !this.materialDetail.comFeeFlag) {
        return '诉讼退费'
      } else if (!this.materialDetail.backFeeFlag && this.materialDetail.comFeeFlag) {
        return '赔偿款'
      } else if (this.materialDetail.backFeeFlag && this.materialDetail.comFeeFlag) {
        return '赔偿款/诉讼退费'
      } else {
        return ''
      }
    },
    stampType() {
      const fin = this.materialDetail.financeSeal ? '财务公章' : ''
      const cust = this.materialDetail.custSeal ? '客户公章' : ''
      const symbol = (fin && cust) ? '/' : ''
      return fin + symbol + cust
    }
  },
  watch: {

  },
  created() {
    this.getClueDetail()
  },
  beforeMount() {

  },
  mounted() {

  },
  updated() {

  },

  methods: {
    // 获取线索详情
    getClueDetail() {
      const url = '/business/other-material/materialInfoById'
      const ajaxData = {
        id: this.detail.id
      }
      this.$get(url, ajaxData).then(res => {
        if (res.code === 0) {
          this.materialDetail = res.data
        }
      })
    }
  }
}
</script>
    <style lang="scss" scoped>
      @import '@/assets/globalStyle.scss';
  .form-wrap {
  padding: 20px;
  .detail-title {
    font-size: 16px;
    margin-bottom: 12px;
    padding-left: 30px;
  }
  .detail-content{
    padding-left: 30px;
    >div{
      line-height: 25px;
    }
  }
}
.title{
  padding-left:10px ;
  font-size: 14px;
  font-weight: 600;
  background-color: #ebedf0;
}
    </style>




// WEBPACK FOOTER //
// src/view/carryoutMaterialManage/components/materialDetail.vue